import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { ExternalProviderRepository } from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface UploadSpeakerResumeCommand {
  file: File;
  externalProviderRepository: ExternalProviderRepository;
}

export const uploadSpeakerResume = createAsyncThunk<string, UploadSpeakerResumeCommand>(
  "externalProvider/uploadSpeakerResume",
  async ({ file, externalProviderRepository }: UploadSpeakerResumeCommand) => {
    return externalProviderRepository.uploadSpeakerResume(file);
  },
);

export const resetUploadSpeakerResume = createAction("externalProvider/resetUploadSpeakerResume");
